import { createContext } from "react";

// Lo que comparte App.js con toda la web:
//  - user: el usuario con sesión (o null)
//  - setUser: para actualizar sus datos (perfil, recetas guardadas...)
//  - cargandoSesion: true mientras se comprueba el token guardado al recargar la página
//  - iniciarSesion(token, userInfo) / cerrarSesion(): abrir y cerrar la sesión
const userContext = createContext({
  user: null,
  setUser: () => {},
  cargandoSesion: false,
  iniciarSesion: () => {},
  cerrarSesion: () => {},
});

export default userContext;
